import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InputTypes, Translation, useGetTranslation } from '@dxp-module/common';
import { Box, FormHelperText, IconButton, InputAdornment, InputLabel, TextField, Typography, } from '@mui/material';
import { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import clsx from 'clsx';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import controlledInputStyles from './controlledInput.styles';
// TODO fix react hook linting error exhaustive-deps
/* eslint-disable react-hooks/exhaustive-deps */
const ControlledInput = ({ name, control, label, disabled, type = InputTypes.TEXT, classes, required, placeholder, }) => {
    const styles = controlledInputStyles();
    const [unhideText, setUnhideText] = useState(false);
    const [inputType, setInputType] = useState(type);
    const getTranslation = useGetTranslation();
    useEffect(() => {
        if (type === InputTypes.PASSWORD) {
            setInputType(unhideText ? InputTypes.TEXT : InputTypes.PASSWORD);
        }
    }, [unhideText]);
    return (_jsx(Controller, { name: name, control: control, render: ({ field, fieldState: { error } }) => (_jsxs(Box, { className: clsx([styles.root, classes?.root]), children: [label && (_jsx(InputLabel, { id: `login:input-label:${name}`, className: clsx([styles.label, classes?.label]), "data-test": `login:input-label:${name}`, required: required, classes: {
                        asterisk: styles.labelAsterisk,
                    }, children: _jsx(Translation, { id: label, component: "Typography", componentProps: { variant: 'subtitle1' } }, void 0) }, void 0)), _jsx(TextField, { ...field, error: !!error, "data-test": `login:input:${name}`, variant: "outlined", type: inputType, placeholder: placeholder ?? (label && getTranslation(label)), className: clsx([
                        styles.textField,
                        classes?.textField,
                        {
                            [styles.error]: error,
                            ...(classes?.error && {
                                [classes.error]: error,
                            }),
                        },
                    ]), InputProps: {
                        classes: {
                            root: clsx([styles.inputRoot, classes?.inputRoot]),
                            input: clsx([styles.input, classes?.input]),
                            disabled: clsx([styles.disabled, classes?.disabled]),
                            notchedOutline: clsx([
                                {
                                    [styles.disabledNotchedOutline]: disabled,
                                    [styles.notchedOutline]: !disabled,
                                    ...(classes?.disabledNotchedOutline && {
                                        [classes.disabledNotchedOutline]: disabled,
                                    }),
                                    ...(classes?.notchedOutline && {
                                        [classes.notchedOutline]: !disabled,
                                    }),
                                },
                            ]),
                        },
                        endAdornment: type === InputTypes.PASSWORD && (_jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { onClick: () => setUnhideText(prevValue => !prevValue), className: clsx([styles.iconButton, classes?.iconButton]), children: unhideText ? _jsx(VisibilityOff, {}, void 0) : _jsx(Visibility, {}, void 0) }, void 0) }, void 0)),
                    }, disabled: disabled }, void 0), error?.message && (_jsx(FormHelperText, { className: clsx([styles.helper, classes?.helper]), error: true, "data-test": `login:input:error:${name}`, children: _jsx(Typography, { variant: "caption", component: "span", children: getTranslation(error.message) }, void 0) }, void 0))] }, void 0)) }, void 0));
};
export default ControlledInput;
//# sourceMappingURL=ControlledInput.js.map